import { Injectable, inject } from '@angular/core';
import { environment } from '../../environments/environment';
import { HttpClient, HttpParams } from '@angular/common/http';
import { ProductObj, ProductsResponse } from '../models/enum';

@Injectable({
  providedIn: 'root'
})
export class OrderCompleteService {
  private readonly http = inject(HttpClient);

  viewTicketDetails(orderCompleteObj) {
    let params: HttpParams;
    if (orderCompleteObj.classPassId) {
      params = new HttpParams().set(
        'classPassId',
        orderCompleteObj.classPassId
      );
    }

    const url =
      environment.apiBaseAddress +
      '/CompleteOrder/ViewTicketDetails/' +
      orderCompleteObj.orderId;
    return this.http.get<any>(url, { params: params });
  }

  // this API is used to show the similar events in the order complate page.
  // showId is null and can be used in future to show more events on ajax call.
  viewSimilarEvents(orderIdentifier, pageSize) {
    var reqObj = {
      orderIdentifier: orderIdentifier,
      pageSize: pageSize
    };
    const url =
      environment.apiBaseAddress + '/CompleteOrder/FetchNextTopEvents/';
    return this.http.post<any>(url, reqObj);
  }

  createNewAccount(orderIdentifier, password) {
    var reqObj = { orderIdentifier: orderIdentifier, password: password };
    const url = environment.apiBaseAddress + '/OrderComplete/CreateNewAccount/';
    return this.http.post<any>(url, reqObj);
  }

  updateEmailAddress(orderIdentifier, email) {
    return this.http.post<any>(
      `${
        environment.apiBaseAddress
      }/CompleteOrder/UpdateEmailAddress/${orderIdentifier}/${email}`,
      null
    );
  }
  sendEmailReceiptMessage(orderIdentifier, email) {
    var reqObj = { orderIdentifier, toemail: [email], ccemail: null };
    const url =
      environment.apiBaseAddress + '/CompleteOrder/SendEmailReceiptMessage';
    return this.http.post<any>(url, reqObj);
  }

  public getWalletUrl(walletUrl: string, responseType: any = 'text') {
    return this.http.get(walletUrl, { responseType: responseType });
  }

  getProductsByShowOrApp(productObj: ProductObj) {
    let params = new HttpParams();
    if (
      productObj.hasOwnProperty('id') &&
      productObj.hasOwnProperty('isProductForApplication')
    ) {
      params = params.set('id', productObj.id);
      params = params.set('isApp', productObj.isProductForApplication);
    }
    const url =
      environment.apiBaseAddress +
      '/CompleteOrder/GetProductsByShowOrApplication/';
    return this.http.get<ProductsResponse>(url, { params: params });
  }
}
